export default Object.freeze({
  SET_STEP: 'SET_STEP',
  INIT_LOAD_FULFILLED: 'INIT_LOAD_FULFILLED',
})
